export const analyticsConfig = {
  gaMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || '',
  metaPixelId: process.env.REACT_APP_META_PIXEL_ID?.trim() || '',
};

export function hasAnyAnalytics() {
  return Boolean(analyticsConfig.gaMeasurementId || analyticsConfig.metaPixelId);
}
